<template>
  <div class="flex items-center justify-center">
    <DataGetter
      v-if="!storeStats"
      @dataAvailable="
        data => {
          rawStats = data?.metaData
        }
      "
      contentId="stats"
    />
    <div class="flex justify-center items-center h-[20rem] w-[20rem] relative">
      <div
        class="absolute w-full h-full pointer-events-none group"
        v-for="(el, i) in formatedStats"
        :key="i"
      >
        <div class="absolute w-full h-full top-0 left-0 group-hover:z-[2]">
          <div
            class="absolute w-full h-full origin-center flex justify-center"
            :style="{
              transform: `rotate(${(el.totalBefore * 360) / totalGraphValue}deg)`,
            }"
          >
            <div
              class="absolute top-0 w-[3%] h-[calc(55%)]"
              :style="{ transform: `rotate(${j * 1}deg)` }"
              style="transform-origin: 50% calc(100% * 50 / 55)"
              v-for="(el2, j) in parseInt(
                (graphValue(el) * 360) / totalGraphValue,
              )"
              :key="j"
              :class="{
                'opacity-0 hidden':
                  j < 1 || j > (graphValue(el) * 360) / totalGraphValue - 1,
                '!opacity-100 !block z-[2]':
                  j == parseInt((graphValue(el) * 360) / totalGraphValue / 2),
              }"
            >
              <div
                class="w-full h-[30%]  duration-300 group-hover:scale-[1.25] pointer-events-auto"
                :class="[el.classes]"
              ></div>
              <div
                v-if="
                  j == parseInt((graphValue(el) * 360) / totalGraphValue / 2)
                "
                class="top-[15%] left-1/2 flex items-center justify-center z-[3] absolute"
                :style="{
                  transform: `rotate(-${(el.totalBefore * 360) / totalGraphValue + j * 1}deg)`,
                }"
              >
                <div
                  class="absolute w-3 h-3 border-2 rounded-full bg-white border-[#FF7955] duration-300 opacity-0 group-hover:opacity-100 group-hover:delay-150"
                ></div>
                <div
                  class="bottom-4 border absolute bg-white px-4 py-2 rounded-xl shadow-b-2xl z-[2] whitespace-nowrap text-center translate-y-1/2 group-hover:translate-y-0 duration-300 opacity-0 group-hover:opacity-100"
                >
                  <div>{{ el.name }}</div>
                  <div>
                    <span class="font-bold text-lg title-color">
                      {{ el.val }}
                    </span>
                    transactions
                  </div>
                  <div>
                    <span class="font-bold text-lg title-color">
                      {{ el.amount }}
                    </span>
                    CFA
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="absolute w-1/2 h-1/2 bg-white shadow-b-2xl rounded-full flex items-center justify-center"
      >
        <div class="text-center">
          <div class="text-2xl">Total</div>
          <div>
            <span class="font-bold text-lg title-color">
              {{ totalCount }}
            </span>
            transactions
          </div>
          <div>
            <span class="font-bold text-lg title-color">
              {{ totalAmount }}
            </span>
            CFA
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import DataGetter from '../utils/DataGetter.vue'

export default defineComponent({
  name: 'PlatformStats',
  components: { DataGetter },
  props: {
    storeStats: {
      type: Object,
      default() {
        return null
      },
    },
  },
  data() {
    return {
      rawStats: this.storeStats || {},
    }
  },
  mounted() {},
  methods: {
    graphValue(stat) {
      return Math.max(stat.val, parseInt(this.totalCount / 10), 1)
    },
  },
  watch: {
    storeStats: {
      deep: true,
      handler(newVal) {
        this.rawStats = newVal || {}
      },
    },
  },
  computed: {
    stats() {
      const doneAmount = this.rawStats?.paymentDoneStats?.amount || 0
      const doneCount = this.rawStats?.paymentDoneStats?.count || 0
      const failedAmount = this.rawStats?.paymentFailedStats?.amount || 0
      const failedCount = this.rawStats?.paymentFailedStats?.count || 0
      const initiatedAmount = this.rawStats?.paymentInitiatedStats?.amount || 0
      const initiatedCount = this.rawStats?.paymentInitiatedStats?.count || 0
      const pendingAmount = initiatedAmount - failedAmount - doneAmount
      const pendingCount = initiatedCount - failedCount - doneCount
      return [
        {
          classes: 'bg-secondary',
          name: 'Echouées',
          val: failedCount,
          amount: failedAmount,
        },
        {
          classes: 'bg-[#F0F4FF]',
          name: 'En attente',
          val: Math.max(pendingCount, 0),
          amount: Math.max(pendingAmount, 0),
        },
        {
          classes: 'bg-[#4368FA]',
          name: 'Réussi',
          val: doneCount,
          amount: doneAmount,
        },
      ]
    },
    totalAmount() {
      let total = 0
      this.stats.forEach(stat => (total += stat.amount))
      return total
    },
    totalGraphValue() {
      let total = 0
      this.stats.forEach(stat => (total += this.graphValue(stat)))
      return total
    },
    totalCount() {
      let total = 0
      this.stats.forEach(stat => (total += stat.val))
      return total
    },
    formatedStats() {
      return this.stats.map((stat, i) => {
        let totalBefore = 0
        if (i) {
          this.stats
            .slice(0, i)
            .forEach(stat => (totalBefore += this.graphValue(stat)))
        }
        return {
          ...stat,
          totalBefore: totalBefore,
        }
      })
    },
  },
})
</script>
